import { Component } from '@angular/core';
import { NavController, NavParams, ToastController } from 'ionic-angular';
import { FormBuilder } from '@angular/forms';
import { Globals } from "../../../../globals";
import { ConfigurationServices } from "../../services";
import { TranslateService } from '@ngx-translate/core';

/**
 * Generated class for the ConfigurationPaymentCryptoPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-configuration-payment-getnet-terminal',
  templateUrl: 'configuration-payment-getnet-terminal.html',
})
export class ConfigurationPaymentGetnetTerminalPage {

  public redsys_top_user_id: number;
  public redsys_top_user_token_hidden: string = '';
  public redsys_top_client_id: string = ''
  public redsys_top_merchant_id: number;


  constructor(public navCtrl: NavController,
    public navParams: NavParams,
    public fb: FormBuilder,
    public configurationServices: ConfigurationServices,
    public globals: Globals,
    public translate: TranslateService,
    public toastCtrl: ToastController) {


  }

  changeGetnetTerminal(active) {
    if (active) {
      this.configurationServices.afs.collection('restaurants').doc(this.globals.restaurant_uid).update({
        'payment_method_redsys_offline': true
      }).then(() => {
        this.globals.restaurant.payment_method_redsys_offline = true;
      });
      let toast = this.toastCtrl.create({
        message: this.translate.instant('config-activado'),
        duration: 2000,
        position: 'top'
      });
      toast.present();
    } else {
      this.configurationServices.afs.collection('restaurants').doc(this.globals.restaurant_uid).update({
        'payment_method_redsys_offline': false
      }).then(() => {
        this.globals.restaurant.payment_method_redsys_offline = false;
      });
      let toast = this.toastCtrl.create({
        message: this.translate.instant('config-desactivado'),
        duration: 2000,
        position: 'top'
      });
      toast.present();
    }
  }


}



// WEBPACK FOOTER //
// ./src/pages/configuration/configuration-payment-methods/configuration-payment-getnet-terminal/configuration-payment-getnet-terminal.ts